import { useEffect, useRef, useState } from "react";

export function RdCursor() {
  const dot = useRef(null);
  const ring = useRef(null);
  const [enabled] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(pointer:fine)").matches
  );
  useEffect(() => {
    if (!enabled) return undefined;
    document.documentElement.classList.add("has-cursor");
    let mx = -100, my = -100, rx = -100, ry = -100, raf;
    const move = (e) => {
      mx = e.clientX; my = e.clientY;
      const t = e.target.closest && e.target.closest("a,button,summary,input,select,textarea,label,[data-cursor]");
      if (ring.current) ring.current.classList.toggle("act", !!t);
    };
    const loop = () => {
      rx += (mx - rx) * 0.16; ry += (my - ry) * 0.16;
      if (dot.current) dot.current.style.transform = "translate(" + mx + "px," + my + "px)";
      if (ring.current) ring.current.style.transform = "translate(" + rx + "px," + ry + "px)";
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("pointermove", move, { passive: true });
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("pointermove", move);
      cancelAnimationFrame(raf);
      document.documentElement.classList.remove("has-cursor");
    };
  }, [enabled]);
  if (!enabled) return null;
  return (
    <>
      <div className="rd-cur-dot" ref={dot} aria-hidden="true" />
      <div className="rd-cur-ring" ref={ring} aria-hidden="true" />
    </>
  );
}
